import { CheckCircle2, XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface QualityGateBadgeProps {
  status: 'passed' | 'failed';
  score?: number;
  className?: string;
}

export function QualityGateBadge({ status, score, className = '' }: QualityGateBadgeProps) {
  const { t } = useTranslation();
  const isPassed = status === 'passed';

  return (
    <div
      className={`
        inline-flex items-center gap-4 rounded-asymmetric-lg border px-8 py-4
        ${isPassed ? 'border-primary bg-surface' : 'border-border bg-surface'}
        ${className}
      `}
    >
      {/* Icon */}
      {isPassed ? (
        <CheckCircle2 className="h-8 w-8 text-text-primary" />
      ) : (
        <XCircle className="h-8 w-8 text-text-muted" />
      )}

      {/* Content */}
      <div className="flex flex-col">
        <span className="text-xs font-medium uppercase tracking-widest text-text-muted font-mono">
          {t('qualityGate.title')}
        </span>
        <span
          className={`text-xl font-bold uppercase font-mono ${isPassed ? 'text-text-primary' : 'text-text-secondary'}`}
        >
          {t(isPassed ? 'qualityGate.passed' : 'qualityGate.failed')}
        </span>
        {score !== undefined && (
          <span className="text-sm text-text-muted font-mono">
            {t('qualityGate.score')}: {score}%
          </span>
        )}
      </div>
    </div>
  );
}
